import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { IconDirection } from 'constants/coreDesignSystem';

import { defaultSize, rotationEnum, sizePropsTypes } from './icons.constants';

const ArrowCheckIcon = ({
  size = defaultSize,
  direction = IconDirection.DOWN,
  className,
  ...props
}) => {
  return (
    <svg
      className={clsx(rotationEnum[direction], className)}
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

ArrowCheckIcon.propTypes = {
  ...sizePropsTypes,
  direction: PropTypes.oneOf(Object.keys(rotationEnum)),
  className: PropTypes.string,
};

export default ArrowCheckIcon;
